import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    ContractCurrency, AdditionalFeesAllowed,
    OtherFeesAllowed,
    FeeChargeability, ProductType,
} from 'app/enums/label.enums'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/RateCard.requests'
import {
    OtherLaneFeesTable,
} from './OtherLaneFees.types'

const config: SkyNetTableTab<keyof OtherLaneFeesTable> = {
    name: 'Other Standard Lane Fees',
    url: RateCardsTabs.OtherLaneFees,
    customUrl: requests.otherLaneFeesFilterRequest().url,
    fields: [
        {
            name: 'feeName',
            labelKey: 'LaneFeesRateCard.feeName',
            componentName: 'EnumValue',
            allowedValuesEnum: {
                ...OtherFeesAllowed, ...AdditionalFeesAllowed,
            },
            width: '15%',
        },
        {
            name: 'feeChargability',
            labelKey: 'LaneFeesRateCard.feeChargability',
            componentName: 'EnumValue',
            allowedValuesEnum: FeeChargeability,
            minWidth: '25%',
        },
        {
            name: 'productType',
            labelKey: 'LaneFeesRateCard.productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
        },
        {
            name: 'description',
            labelKey: 'LaneFeesRateCard.description',
            minWidth: '35%',
        },
        {
            name: 'currency',
            labelKey: 'LaneFeesRateCard.currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
            filterField: 'currency',
            filterType: FilterType.Array,
        },
        {
            name: 'feeValue',
            alignTextRight: true,
            labelKey: 'LaneFeesRateCard.feeValue',
        },
    ],
}

export default config
